export const ui = {
    // Modal Contact Gustave Rideau
    gustaveModal: {
        container: document.querySelector('.modal-gustave') as HTMLElement,
        open: document.querySelector('.modal-gustave-open') as HTMLButtonElement,
        close: document.querySelector('.modal-gustave-close') as HTMLButtonElement,
    },

    // Modal Contact Gift
    giftModal: {
        container: document.querySelector('.modal-gift') as HTMLElement,
        open: document.querySelector('.modal-gift-open') as HTMLButtonElement,
        close: document.querySelector('.modal-gift-close') as HTMLButtonElement,
    },

    // Modal Sponsor
    sponsorModal: {
        container: document.querySelector('.modal-sponsor') as HTMLElement,
        open: document.querySelector('.modal-sponsor-open') as HTMLButtonElement,
        close: document.querySelector('.modal-sponsor-close') as HTMLButtonElement,
    },

    // Modal Create Project
    createProjectModal: {
        container: document.querySelector('.modal-createProject') as HTMLElement,
        open: document.querySelector('.modal-createProject-open') as HTMLButtonElement,
        close: document.querySelector('.modal-createProject-close') as HTMLButtonElement,
        modalNextStep: document.querySelector('.modal-createProject-nextStep') as HTMLButtonElement,
        modalFirstStep: document.querySelector('.modal-createProject-firstStep') as HTMLElement,
        modalSecondStep: document.querySelector('.modal-createProject-secondStep') as HTMLElement,
    },

    // Modal Onboarding
    onboardingModal: {
        container: document.querySelector('.modal-onboarding') as HTMLElement,
        open: document.querySelector('.modal-onboarding-open') as HTMLButtonElement,
        close: document.querySelector('.modal-onboarding-close') as HTMLButtonElement,
        modalNextStep: document.querySelector('.modal-onboarding-nextStep') as HTMLButtonElement,
        modalPreviousStep: document.querySelector('.modal-onboarding-previousStep') as HTMLButtonElement,
        modalFirstStep: document.querySelector('.modal-onboarding-firstStep') as HTMLElement,
        modalSecondStep: document.querySelector('.modal-onboarding-secondStep') as HTMLElement,
        modalThirdStep: document.querySelector('.modal-onboarding-thirdStep') as HTMLElement,
        onboardingTitle: document.querySelector('.onBoarding-title') as HTMLElement,
        btnsContainer: document.querySelector('.modal__body__btns') as HTMLElement,
    }
}
